export default "<div class=\"close-button-wrapper\"><img [src]=\"'assets/images/plus.png'\"></div>\r\n"